import React from 'react';
import { UNSAFE_LAYERING } from '@atlaskit/layering';
import { MinimizableModalProvider } from '../controllers/use-minimizable-modal';
import type { MinimizableModalProps } from '../types';
import { ModalContainer } from './modal-container';
import { ReParenter } from './reparenter';

export const MinimizableModal = ({
	children,
	Container = ModalContainer,
	initialView,
	onClose,
	view,
	onViewChange,
}: MinimizableModalProps) => (
	// See more details about UNSAFE_LAYERING https://hello.atlassian.net/wiki/spaces/~63ff0a61f00d095406f28492/pages/2984762483/Layering+package+introduction
	<UNSAFE_LAYERING isDisabled={false}>
		<MinimizableModalProvider
			initialView={initialView}
			onClose={onClose}
			view={view}
			onViewChange={onViewChange}
		>
			<ReParenter Parent={Container}>{children}</ReParenter>
		</MinimizableModalProvider>
	</UNSAFE_LAYERING>
);
